// src/utils/googleCalendarClient.js
//
// Pass 88 — thin CLIENT wrapper over the server-side Google Calendar callables. The browser NEVER calls
// Google or touches OAuth tokens (§4/§12): it only (a) asks the server to mint a one-time connect state
// then hands the browser to the server redirect endpoint, (b) triggers an authorized server sync, or
// (c) disconnects. All authority is re-checked server-side against the reloaded canonical booking.
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// Base URL for the onRequest OAuth endpoints (gen2 us-central1). Config-overridable; defaults to the
// project's Cloud Functions origin. Only used to forward the browser into the server-owned OAuth flow.
const FN_BASE = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_FUNCTIONS_BASE_URL)
  || 'https://us-central1-sports-video-anaylsis.cloudfunctions.net';

export async function beginGoogleCalendarConnect({ organizationId, ownerType = 'organization', ownerId = '' } = {}) {
  if (!organizationId) throw new Error('organizationId is required');
  const call = httpsCallable(functions, 'googleCalendarBeginConnect');
  const res = await call({ organizationId, ownerType, ownerId });
  const state = res?.data?.state;
  if (!state) throw new Error('Could not start calendar connection.');
  const url = `${FN_BASE}/googleCalendarAuthRedirect?state=${encodeURIComponent(state)}`;
  // Hand the browser to the server-owned OAuth redirect (not a provider URL the client built).
  if (typeof window !== 'undefined') window.location.assign(url);
  return { state, url };
}

export async function disconnectGoogleCalendar({ calendarConnectionId, organizationId } = {}) {
  const call = httpsCallable(functions, 'googleCalendarDisconnect');
  const res = await call({ calendarConnectionId, organizationId });
  return res?.data || { ok: true };
}

export async function syncBookingToCalendar({ bookingId, calendarConnectionId = '' } = {}) {
  if (!bookingId) throw new Error('bookingId is required');
  const call = httpsCallable(functions, 'syncBookingToCalendar');
  const res = await call({ bookingId, calendarConnectionId });
  return res?.data || {};
}
